<template>
  <FormControl
    :label="label"
    :indent="indent"
    :required="required"
    :class="containerClass"
    @disabled="onSetDisabled"
  >
    <div slot-scope="slotProps">
      <input
        v-if="!multiline"
        @change="onChange"
        @keypress="onKeypress"
        :type="!secure ? 'text' : 'password'"
        v-model="model[name]"
        class="form-control"
        :placeholder="placeholder != null ? placeholder : label"
        tabindex="0"
        :class="{ 'load-spinner': loading, 'is-invalid': slotProps.hasError }"
        :disabled="getIsDisabled()"
        autocomplete="off"
      />

      <textarea
        v-else
        @change="onChange"
        @keypress="onKeypress"
        class="form-control"
        :style="'min-height:' + minHeight"
        :value="model[name]"
        :placeholder="placeholder != null ? placeholder : label"
        :disabled="getIsDisabled()"
      ></textarea>
    </div>
  </FormControl>
</template>

<script>
import FormControl from "./FormControl";
import formControlMixin from "./mixins/form-control.mixin.js";

export default {
  name: "text-input",
  props: [
    "required",
    "indent",
    "label",
    "placeholder",
    "model",
    "name",
    "multiline",
    "secure",
    "containerClass",
    "loading",
    "disabled",
    "minHeight",
  ],
  mixins: [formControlMixin],
  components: {
    FormControl
  },
  methods: {
    onChange(e) {
      if (this.multiline) {
        this.model[this.name] = e.target.value;
      }

      this.$emit('change', this.getValue());
    },
    onKeypress(e) {

      this.$emit('keypress', this.getValue());
    }
  }
};
</script>
